import { Component, OnDestroy, OnInit, AfterViewInit, ElementRef } from '@angular/core';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { AppState, selectCurrentTrip, Trip } from '../../../state';
import { Device, deviceIds } from '../../../../assets/js/embross-device-manager';
import { Logging } from '../../../services/logging/logging.service';
import { ApplinkService } from '../../../services/hardware/applink.service';
import { AppRoutes } from 'src/app/app-routing.module';
import { AccessibilityService } from 'src/app/services/accessibility/accessibility.service';

@Component({
  selector: 'app-checked-in-options',
  templateUrl: './checked-in-options.component.html',
  styleUrls: ['./checked-in-options.component.scss'],
})
export class CheckedInOptionsComponent implements OnInit, AfterViewInit, OnDestroy {
  barcodeReader: Device;
  hazmatRoute = AppRoutes.HAZMAT_PROHIBITED;
  itineraryRoute = AppRoutes.ITINERARY;
  private currentTripObserver$: Observable<Trip>;
  private currentTripSubscription;
  private currentNumberOfBags;
  private tripHasBags = false;
  private appExitButton;

  constructor(
    public router: Router,
    private logging: Logging,
    private store: Store<AppState>,
    private applinkService: ApplinkService,
    private accessibilityService: AccessibilityService,
    private el: ElementRef
  ) {
    this.currentTripObserver$ = this.store.pipe(select(selectCurrentTrip));
    this.currentTripSubscription = this.currentTripObserver$.subscribe((value) => {
      if (value.activeSegment !== undefined) {
        this.currentNumberOfBags = value.activeSegment.getNumBags();
        if (this.currentNumberOfBags > 0) {
          this.tripHasBags = true;
        }
      }
    });
  }

  ngOnInit() {
    this.barcodeReader = this.applinkService.getDeviceManager().getDevice(deviceIds.BARCODE_READER);
    this.barcodeReader.disable();
    this.logging.infoUiAlreadyCheckedInPageDisplayed(0);
  }
  ngAfterViewInit(): void {
    const allElements = [...this.el.nativeElement.querySelectorAll('[tabindex]'), ...this.appExitButton];
    this.accessibilityService.setElementsToRead(allElements);
  }

  retrieveExitAppButtonElement($event) {
    this.appExitButton = $event;
  }

  ngOnDestroy() {
    if (this.currentTripSubscription) {
      this.currentTripSubscription.unsubscribe();
    }
  }

  onExitClick() {
    this.logging.infoUiExitSelected(0);
  }

  onPrintOnlyClick() {
    this.logging.infoUiAlreadyCheckedinPagePrintOnlySelected(0);
  }

  onModifyItineraryClick() {
    if (this.hasBags()) {
      this.logging.infoUiAlreadyCheckedInPageCheckBagsSelected(0);
    }
    this.logging.infoUiAlreadyCheckedinPageModifySelected(0);
  }
  hasBags() {
    return this.tripHasBags;
  }
}
